import { useQuery } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';

import { PublicationNewAliasRequest } from '@/module/Author/Publication/model/PublicationTypes';
import { useReviewAddNewAlias } from '@/module/Author/Review/model/ReviewQuery';
import { reviewMembershipOptions } from '@/module/Nomen/ReviewMembership/model/ReviewMembershipModel';

import { Id, useAppNotification } from '@feature/utils';

import { PublicationSearchClaimable } from '../Publication/PublicationSearchClaimable';

export function ReviewSearchClaimable() {
  const notification = useAppNotification();
  const navigate = useNavigate();

  const { data: memberships, isLoading, isError } = useQuery(reviewMembershipOptions.getAll());

  const mutation = useReviewAddNewAlias();
  const onAddNewAlias = (publicationId: Id, request: PublicationNewAliasRequest) =>
    mutation.mutate(
      { reviewId: publicationId, request: request },
      {
        onSuccess: review => {
          notification.success();
          navigate({ to: '/author/review/$reviewId', params: { reviewId: String(review.id) } });
        },
        onError: notification.error,
      },
    );

  return (
    <PublicationSearchClaimable
      memberships={memberships}
      membershipsLoading={isLoading}
      membershipsError={isError}
      onAddNewAlias={onAddNewAlias}
    />
  );
}
